import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import './BottomBox.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router-dom';


const BottomBox = (props) => {
    const playnotify = () => {
        toast("Coming Soon!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            theme: "dark"
        });
    };
    const applenotify = () => {
        toast("Coming Soon!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            theme: "dark"
        });
    };
    const { history } = props;
    return (
        <Box
            sx={theme => ({
                [theme.breakpoints.up('sm')]: { margin: "125px 0px 0px 0px", height: '70%', width: '100%', overflow: 'hidden', backgroundColor: '#202020' },
                [theme.breakpoints.between('0', '600')]: { height: '75%', maxHeight: '100%', width: '100vw', maxWidth: '100%', overflow: 'hidden', backgroundColor: '#202020' },
                [theme.breakpoints.down('xs')]: { height: '100vh', maxHeight: '100%', width: '100vw', maxWidth: '100%' }

            })}
        >

            <div className="footer-container">

                <div className="f-left">
                    <div style={{ cursor: 'pointer' }} className='f-head' onClick={() => history.push('/')}>Untouched</div>
                    <div className='f-moto'>Cleanliness & Hygiene Devices</div>
                </div>


                <div className="f-company">
                    <p id="bottom__company">Company</p>
                    <div style={{ cursor: 'pointer' }} onClick={() => history.push('/story')}>Our Story</div>
                    <div style={{ cursor: 'pointer' }} onClick={() => history.push('/invest')}>Invest Now</div>
                    <div style={{ cursor: 'pointer' }} onClick={() => history.push('/blog')}>Blogs</div>
                </div>

                <div className="f-contact">
                    <p id="bottom__contact">Contact</p>
                    <div style={{ cursor: 'pointer' }} onClick={() => history.push('/faq')}>FAQ</div>
                    <div style={{ cursor: 'pointer' }} onClick={() => history.push('/career')}>Careers</div>
                    <div style={{ cursor: 'pointer' }} onClick={() => history.push('/contact')}>Contact Us</div>
                </div>



                <div className="f-right">
                    <div className="f-social">
                        <p>On Social Networks</p>
                        <div className='s-grp'>
                            <a target='_blank' rel="noreferrer" href="https://www.linkedin.com/company/gountouched/"><img id="s-icon" src="/images/social-icon/Linkedin Black.svg" alt="" /></a>
                            <a target='_blank' rel="noreferrer" href="https://twitter.com/gountouched"><img id="s-icon" src="/images/social-icon/Twitter Black.svg" alt="" /></a>
                            <a target='_blank' rel="noreferrer" href="https://www.instagram.com/go_untouched/"> <img style={{ backgroundColor: 'white', borderRadius: '15px' }} id="s-icon" src="/images/social-icon/Instagram Black.svg" alt="" /></a>
                        </div>
                    </div>
                    {/* <p>Discover Our App</p> */}
                    {/* <div className="f-app">
                    
                    <div className="play-button">
                    <button onClick={playnotify} >
                        <div className="play-bt">
                        <div className="img-store">
                        <img id='play' style={{width:'1.5em',height:'1.5em',marginTop:4}} src="/images/app-icon/play.png" alt="play" />
                        </div>
                        <div className="theo-store">
                        <div>Available on</div>
                        <div><b>Google Play</b></div>
                        </div>
                        </div>
                    </button>
                    
                    </div>

                    <div className="app-button">
                    <button onClick={applenotify} >
                    <div className="app-bt">
                    <div className="img-store">    
                    <img  style={{width:'1.5em',height:'1.5em',marginTop:4}} src="/images/app-icon/apple.png" alt="apple" />
                    </div>
                    <div  className="theo-store">
                    <div>Download on the</div>
                    <div style={{marginLeft:-20}}><b>App Store</b></div>
                    </div>
                    </div>
                    </button>
                    <ToastContainer />
                    </div>

                </div> */}
                </div>
            </div>



            <div className="u-end">
                <p id='U'>© 2022 Untouched</p>
                {/* <p id='S'>Innovation to fight COVID-19 from SOARON</p> */}
            </div>

        </Box>
    );
}

export default withRouter(BottomBox);